export default {
  tagsList: state => {
    return state.tags;
  }
};
